import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Webcam from 'react-webcam';
import BottomDrawer from '../../components/common/BottomDrawer';
import CameraButton from '../../components/common/CameraButton';
import { InputBackOffice } from '../../components/common/InputBackoffice';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import Spinner from '../../components/common/Spinner';
import countries from '../../lib/countries';
import {
  ArrowPolygon,
  BrowseFilesButton,
  Button,
  Flexed,
  PageTitle,
  Select
} from '../../styles/GlobalComponents';
import { ChangeEmailSteps } from './EmailChange/ChangeEmailSteps';

import {
  CountryText,
  FlexCenter,
  SInput,
  SInputContainer,
  SidebarSubtitle,
  SidebarTitle
} from '../../styles/stylesStyled';

import { useTranslation } from 'react-i18next';

import i18next from 'i18next';
import { ErrorToast } from '../../components/common/Toasts/Toasts';
import { useWindowWide } from '../../helpers/wideScreen';
import {
  ProfileImage,
  ProfileImagePlaceholder,
  ProfilePicture
} from '../../styles/GlobalComponents';
import {
  Icon,
  IconCheckMark,
  IconEditSettings,
  IconSearch
} from '../../styles/Icons';
import { Required2FA } from './EmailChange/Required2FA';
import { addAddress, uploadProfileImage } from './Settings.actions';
import {
  Box,
  CamCapturedCircle,
  CamCircle,
  CameraUnderlineText,
  Label,
  Username
} from './SettingsStyled';
import { languages } from './countryFlags';

import { useAppSelector } from '../../app/hooks';
import { P3 } from '../../styles/FontStyles';
import { color } from '../../styles/GlobalStyles';
import { settingsInit, updateUsername } from './Settings.actions';

export const AccountSettings = () => {
  const { t } = useTranslation('settings');
  const [countryList, setCountryList] = useState(countries);
  const [countryCode, setCountryCode] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [zip, setZip] = useState('');
  const [coutr, setCoutr] = useState('');
  const [city, setCity] = useState('');
  const [userCountry, setUserCountry] = useState('');
  const [emailChange, setEmailChange] = useState(false);

  const dispatch = useDispatch();
  const { user, loading } = useAppSelector((state) => state.settings);
  const { loading: loadingUserInfo } = useAppSelector((state) => state.auth);

  const wide = useWindowWide(800);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [changeEmail, setChangeEmail] = useState(false);
  const [username, setUsername] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [isPermanent] = useState(false);
  const [emailStep, setEmailStep] = useState(1);

  const [searchTerm, setSearchTerm] = useState('');

  // const [languageDropdown, setLanguageDropdown] = useState(false);

  const onClose = React.useCallback(() => {
    setIsVisible(false);
  }, []);

  const videoConstraints = {
    facingMode: 'user',
    width: 311,
    height: 311
  };

  const checkCountry = (country: any) => {
    setCountryList(
      countryList.map((item) =>
        item.name === country.name
          ? {
              ...item,
              checked: true
            }
          : {
              ...item,
              checked: false
            }
      )
    );
  };

  const [image, setImage] = useState('');

  const webcamRef = useRef<any>(null);

  const [bigDrawer, setBigDrawer] = useState(false);

  const handleOpen = () => {
    setBigDrawer(true);
    setIsVisible2(false);
  };

  const [isVisible2, setIsVisible2] = React.useState(false);
  const onClose2 = React.useCallback(() => {
    setIsVisible2(false);
  }, []);

  const uploadFileHandler = async (event: any) => {
    const fileUploaded = event.target.files[0];

    const formData = new FormData();
    formData.append('image', fileUploaded);

    dispatch(uploadProfileImage(formData));
  };

  const captureProfile = useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);

    await convertImage(imageSrc, 'profile.jpeg');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    webcamRef,
    setImage
    //  dispatch
  ]);

  const convertImage = async (image: any, imageName: any) => {
    const response = await image;

    const blob = await fetch(response).then((res) => res.blob());

    const file = new File([blob], imageName, { type: 'image/jpeg' });

    const formData = new FormData();
    formData.append('image', file);

    dispatch(uploadProfileImage(formData));
  };

  useEffect(() => {
    fetch(`https://api.ipregistry.co/?key=${process.env.REACT_APP_IP_REGISTRY}`)
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {
        setUserCountry(payload?.location?.country?.name);
      });
  }, [dispatch]);

  const currentLanguage = i18next.language || window.localStorage.i18nextLng;

  const language =
    languages.find((lang) => lang.code === currentLanguage) ?? languages[0];

  if (loadingUserInfo || loading) return <Spinner fullScreen={true} />;

  return (
    <>
      <PageTitle>{t('account.title')}</PageTitle>
      <FlexCenter style={{ marginBottom: wide ? 40 : 32 }}>
        <div
          style={{ position: 'relative' }}
          onClick={() => setIsVisible2(true)}>
          <ProfilePicture
            size={wide ? '83px' : '55px'}
            style={{
              marginRight: '20px'
            }}>
            {user ? (
              user?.profileImageUrl ? (
                <ProfileImage src={user?.profileImageUrl} alt='Upload' />
              ) : (
                <ProfileImagePlaceholder
                  size={wide ? '83px' : '55px'}
                  font={wide ? '36px' : '20px'}>
                  {user?.name?.charAt(0) + user?.surname?.charAt(0)}
                </ProfileImagePlaceholder>
              )
            ) : (
              ''
            )}
          </ProfilePicture>
          <Icon
            style={{
              width: 23,
              height: 23,
              position: 'absolute',
              top: 10,
              right: 12,
              zIndex: 100,
              cursor: 'pointer'
            }}>
            <IconEditSettings />
          </Icon>
        </div>
        <div>
          <Username>{user?.name + ' ' + user?.surname}</Username>
          <Label>ID: {user?.id}</Label>
        </div>
      </FlexCenter>
      <Box>
        <Flexed between mb='16'>
          <div>
            <Label>{t('account.username')}</Label>
            <P3>{user?.username}</P3>
          </div>

          <Button maxWidth='150px' negative onClick={() => setIsOpen(true)}>
            {t('account.change')}
          </Button>
        </Flexed>

        <Flexed between mb='16'>
          <div>
            <Label>{t('account.email')}</Label>
            <P3>{user?.email}</P3>
          </div>

          <Button
            maxWidth='150px'
            negative
            onClick={() => {
              setChangeEmail(true);
              setEmailStep(1);
            }}>
            {t('account.change')}
          </Button>
        </Flexed>

        <Flexed between>
          <div>
            <Label>{t('account.main_address')}</Label>
            <P3>
              {user?.addresses?.map(
                (address) => address.isPermanent && address.addressLine1
              )}
            </P3>
          </div>

          <Button maxWidth='150px' negative onClick={() => setIsOpen2(true)}>
            {t('account.edit')}
          </Button>
        </Flexed>
      </Box>
      {/* <Box>
        <Flexed center rowSM alignStartSM gap='10px' between>
          <div>
            <Label>{t('account.preferred_language')}</Label>
          </div>

          <LanguageWrapper
            htmlFor='lang'
            onClick={() => setLanguageDropdown(!languageDropdown)}>
            <Flexed gap='10px' center>
              <img
                style={{ width: wide ? 30 : 30 }}
                src={language.flag}
                alt='lang'
              />
              <P3 color={color.colors.neutral900}>{language.name}</P3>
              <ArrowPolygon direction={languageDropdown ? 'up' : 'down'} />
            </Flexed>

            <LanguageDropdown isOpen={languageDropdown}>
              {languages.map((language, i) => {
                return (
                  <Flexed
                    key={i}
                    pointer
                    gap='10px'
                    center
                    onClick={() => {
                      i18next.changeLanguage(language.code);
                    }}>
                    <img style={{ width: 40 }} src={language.flag} alt='' />
                    <P3 color={color.colors.neutral900}>{language.name}</P3>
                  </Flexed>
                );
              })}
            </LanguageDropdown>
          </LanguageWrapper>
        </Flexed>
      </Box> */}

      <SidebarModal
        isOpen={isOpen}
        setOpen={setIsOpen}
        title={t('account.change_username')}
        sidebarWidth={'508px'}>
        <SidebarTitle>{t('account.enter_new_username')}</SidebarTitle>
        <SidebarSubtitle>{t('account.sidebar_subtitle')}</SidebarSubtitle>
        <InputBackOffice
          type='text'
          value={username.replace(/[^A-Z0-9]/gi, '') || ''}
          onChange={(e: string) =>
            setUsername(e.replace(/[^A-Z0-9]/gi, '').toLowerCase())
          }
          placeholder='New username'
        />
        <Button
          m='20px auto'
          w='100%'
          onClick={() => {
            if (!username) {
              ErrorToast(t('account.username_message'));
            } else {
              dispatch(updateUsername({ username, setIsOpen }));
            }
          }}>
          {t('account.save_changes')}
        </Button>
      </SidebarModal>

      <SidebarModal
        isOpen={isOpen2}
        setOpen={setIsOpen2}
        title={t('account.add_temporary_address')}
        sidebarWidth={'508px'}>
        <SidebarTitle>{t('account.enter_your_address')}</SidebarTitle>
        <SidebarSubtitle>{''}</SidebarSubtitle>
        <InputBackOffice
          type='text'
          placeholder={t('account.address_line_1')}
          value={address1}
          onChange={setAddress1}
        />
        <InputBackOffice
          type='text'
          placeholder={t('account.address_line_2')}
          value={address2}
          onChange={setAddress2}
        />
        <InputBackOffice
          type='text'
          placeholder={t('account.zip_code')}
          value={zip}
          onChange={setZip}
        />
        <InputBackOffice
          type='text'
          placeholder={t('account.city')}
          value={city}
          onChange={setCity}
        />

        <Select
          onClick={() => setIsVisible(!isVisible)}
          color={!coutr && color.colors.neutral700}>
          <span>{coutr || t('account.country')}</span>
          <ArrowPolygon direction={''} />
        </Select>

        <Button
          m='20px auto'
          onClick={() => {
            if (!address1 && !address2 && !city && !zip && !coutr) {
              ErrorToast(t('account.err_fill_all_fields'));
            } else {
              dispatch(
                addAddress({
                  addressLine1: address1,
                  addressLine2: address2,
                  zipCode: zip,
                  country: coutr,
                  countryCode,
                  isPermanent,
                  city,
                  setIsOpen2
                })
              );
            }
          }}>
          {t('account.save_changes')}
        </Button>
      </SidebarModal>
      <SidebarModal
        isOpen={changeEmail}
        setOpen={setChangeEmail}
        title={t('account.change_email')}
        sidebarWidth={'508px'}
        hasCloseButton={emailStep === 3 ? false : true}
        overlayClose={emailStep === 3 ? true : false}>
        <ChangeEmailSteps step={emailStep} setStep={setEmailStep} />
      </SidebarModal>

      <BottomDrawer isVisible={isVisible} onClose={onClose} height={'90vh'}>
        <SInputContainer>
          <Icon mr='8' color={color.colors.primary900}>
            <IconSearch />
          </Icon>
          <SInput
            placeholder={t('Search')}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </SInputContainer>
        {countryList
          ?.sort((a) => (a.name === userCountry ? -1 : 1))
          .filter((value) => {
            if (searchTerm === '') {
              return value;
            } else if (
              value.name.toLowerCase().includes(searchTerm.toLowerCase())
            ) {
              return value;
            } else return null;
          })
          .map((country, i) => {
            if (country.hidden) return null;
            return (
              <div
                onClick={() => {
                  setCoutr(country.name);
                  setCountryCode(country.code);
                  setIsVisible(false);
                  checkCountry(country);
                }}
                key={i}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  cursor: 'pointer'
                }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '20px'
                  }}>
                  <img
                    src={country.flag}
                    alt='flag'
                    style={{
                      marginRight: '20px',
                      width: '28px',
                      height: '20px'
                    }}
                  />

                  <CountryText checked={false}>{country.name}</CountryText>
                </div>
                {country.checked && (
                  <Icon mb='20' color={color.colors.primary900}>
                    <IconCheckMark />
                  </Icon>
                )}
              </div>
            );
          })}
      </BottomDrawer>

      <SidebarModal
        isOpen={isVisible2}
        setOpen={onClose2}
        title={t('account.add_profile_photo')}
        sidebarWidth={'508px'}>
        <div>
          <Button m='20px auto' opacity='true' onClick={handleOpen}>
            {t('account.take_profile_photo')}
          </Button>

          <BrowseFilesButton>
            <input
              type='file'
              style={{ display: 'none' }}
              onChange={(e) => {
                uploadFileHandler(e);
                setIsVisible2(false);
              }}
            />
            {t('account.upload_profile_photo')}
          </BrowseFilesButton>
        </div>
      </SidebarModal>

      <SidebarModal
        isOpen={bigDrawer}
        setOpen={setBigDrawer}
        title={t('account.add_profile_photo')}
        sidebarWidth={'508px'}>
        {image ? (
          <FlexCenter style={{ flexDirection: 'column' }}>
            <CamCapturedCircle>
              <img src={image} alt='captured' />
            </CamCapturedCircle>
            <Button
              onClick={() => {
                setBigDrawer(!bigDrawer);
                dispatch(settingsInit());
              }}
              m='20px 0 20px 0'>
              {t('account.image_is_clear')}
            </Button>
            <CameraUnderlineText onClick={() => setImage('')}>
              {t('account.retake')}
            </CameraUnderlineText>
          </FlexCenter>
        ) : (
          <FlexCenter style={{ flexDirection: 'column' }}>
            <CamCircle>
              {bigDrawer && (
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  videoConstraints={videoConstraints}
                  screenshotFormat='image/jpeg'
                  forceScreenshotSourceSize={true}
                />
              )}
            </CamCircle>

            <CameraButton click={captureProfile} />
          </FlexCenter>
        )}
      </SidebarModal>

      <SidebarModal
        isOpen={emailChange}
        setOpen={setEmailChange}
        title={`Change email`}
        sidebarWidth={'508px'}>
        <Required2FA />
      </SidebarModal>
    </>
  );
};
